import React, { ReactNode, useState } from 'react'

import { Button, ButtonProps } from '../../components/button/button.js'
import { Textfield, TextfieldProps } from '../../components/forms/textfield/textfield.js'
import { GridColumn } from '../../components/grid/grid-column.js'
import { Grid } from '../../components/grid/grid.js'
import { PlusIcon } from '../../components/icon/icon.js'
import {
    Modal,
    ModalCloser,
    ModalContent,
    ModalFooter,
    ModalHeader,
    ModalProps,
    ModalProvider,
    ModalProviderProps,
    ModalTrigger,
} from '../../components/modal/modal.js'

export interface NicknameModalProps extends Omit<ModalProps, 'children' | 'onClose'> {
    cancelButton: ButtonProps
    input: TextfieldProps
    saveButton: ButtonProps
    triggerButton: ButtonProps
    title: string
    text?: ReactNode
    onChange?: (value: string) => void
    onClose?: ModalProviderProps['onClose']
    onOpen?: ModalProviderProps['onOpen']
}

export const NicknameModal = (props: NicknameModalProps): JSX.Element => {
    const { cancelButton, input, onChange, onClose, onOpen, saveButton, text, title, triggerButton, ...rest } = props

    const [value, setValue] = useState<string>(input.value)

    const handleChange = (newValue: string) => {
        setValue(newValue)

        if (onChange) {
            onChange(newValue)
        }

        if (input.onChange) {
            input.onChange(newValue)
        }
    }

    return (
        <ModalProvider onClose={onClose} onOpen={onOpen}>
            <ModalTrigger>
                <Button iconLeft={PlusIcon} style="link" {...triggerButton} />
            </ModalTrigger>
            <Modal {...rest} size="small">
                <ModalHeader>
                    <h1>{title}</h1>
                </ModalHeader>
                <ModalContent>
                    <div className="text">
                        {text}
                        <Textfield {...input} onChange={handleChange} bordered={true} />
                    </div>
                </ModalContent>
                <ModalFooter>
                    <Grid>
                        <GridColumn width={['xs-2']}>
                            <ModalCloser>
                                <Button variant="secondary" {...cancelButton} isBlock={true} />
                            </ModalCloser>
                        </GridColumn>
                        <GridColumn width={['xs-2']}>
                            <ModalCloser>
                                <Button isDisabled={value.length === 0} {...saveButton} isBlock={true} />
                            </ModalCloser>
                        </GridColumn>
                    </Grid>
                </ModalFooter>
            </Modal>
        </ModalProvider>
    )
}
